define.alias("shared/services/shared/popup-manager", "media/services/shared/popup-manager");